// extracted by mini-css-extract-plugin
export default {"wrapper":"about_wrapper__UttIR","firstBanner":"about_firstBanner__9oTdh","content":"about_content__lZs3R","story":"about_story__O1jWi"};